import { render, staticRenderFns } from "./filter-wrapper.vue?vue&type=template&id=2842c971&scoped=true&"
import script from "./filter-wrapper.vue?vue&type=script&lang=js&"
export * from "./filter-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842c971",
  null
  
)

export default component.exports